import React, { useContext, useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import moment from 'moment';
import { AppStorage } from '../../../Core/Service/storage-service';
import { ExpBaseURL } from '../../../Core/Service/http-calls';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { useWindowSize } from '../../../Core/Controls/ScreenResolution';
import './dashboard.scss';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { getBranchAndFranchise } from '../../../Core/Service/branch-screen-service';
import { GetArchivedJobsExcelFile } from '../../../Core/Service/workflow-service';
import AppContext from '../../../App/AppContext';
import ReactDOM from 'react-dom';

var grid1;
var $ = window.$;
let storedFiltterValue = {};
let branchList = [];
let franchiseList = [];

const GijgoGrid = (props) => {
    const token = AppStorage.getToken();
    const [state, setState] = useState({});
    const [WindowWidths, WindowHeights] = useWindowSize();
    const { hideModal, showToast, portalSettings } = useContext(AppContext);

    useEffect(() => {
        console.log('opopopo');
        if (grid1 && grid1.data().columns) {
            grid1.data().columns = [...props.columns];
        }
    }, [props.isGridColumnReload]);

    useEffect(async () => {
        if (token) {
            pullArchivedJobsAndUpdateState();
        } else {
            window.location = '/';
            AppStorage.performLogout();
        }
    }, [token, props.filterList, props.isReload]);

    useEffect(async () => {
        if (token) {
            let res = await getBranchAndFranchise();
            if (res.success) {
                branchList = res.data.branches;
                franchiseList = res.data.franchiseRecords;
                props.parentSetbranchList && props.parentSetbranchList(res.data.branches);
            }
        }
    }, [token]);

    var GijgoFilterExtension = (function () {
        function DropdownFilter(grid, propertyName, dropdown, changeValueConversion) {
            var id = $(grid).attr('id');
            var rowXPath = '#' + id + ' thead tr[data-role="filter"]';
            var filterRow = $(rowXPath);
            if ($(filterRow).length == 1) {
                var colXPath = 'th [data-field="' + propertyName + '"]';
                var filterInput = $(filterRow).find(colXPath);
                if ($(filterInput).length) {
                    $(filterInput).parent().addClass('grid-filter-select-th');
                    $(dropdown).attr('data-field', propertyName);
                    $(filterInput).replaceWith(dropdown);
                    $(dropdown).on('change', function () {
                        ChangeFilter(grid, propertyName, $(this), changeValueConversion);
                    });
                }
            }
        }

        function ChangeFilter(grid, propertyName, ddl, changeValueConversion) {
            if (changeValueConversion) {
                var propArr = changeValueConversion(ddl, propertyName, grid);
                $(propArr).each(function (i, obj) {
                    grid.data().params[obj.propertyName] = obj.value;
                });
                if (propArr.length) {
                    grid.reload();
                }
            } else {
                grid.data().params[propertyName] = $(ddl).val();
                grid.reload();
            }
        }

        return {
            Dropdown: DropdownFilter
        };
    })();

    // const GijgoActionBtn = (grid, propertyName, dropdown) => {
    //     var id = $(grid).attr('id');
    //     var rowXPath = '#' + id + ' thead tr[data-role="filter"]';
    //     var filterRow = $(rowXPath);
    //     if ($(filterRow).length) {
    //         var colXPath = 'th [data-field="' + `action` + '"]';

    //         var filterInput = $(filterRow).find(colXPath);
    //         if ($(filterInput).length) {
    //             $(filterInput).replaceWith(dropdown);
    //         }
    //     }
    // };

    const setDataSource = (gridInstance, getUrl) => {
        const onSuccessFunc = function (response) {
            gridInstance.render({
                records: response.data.rows,
                total: response.data.total
            });
        };

        gridInstance.data().dataSource = {
            url: `${ExpBaseURL}/api/${getUrl}`,
            headers: { Authorization: `Bearer ${token}`, domainName: window.location.host.includes('localhost') ? 'localhost' : window.location.host },
            success: onSuccessFunc
        };
    };

    const pullArchivedJobsAndUpdateState = async () => {
        window.$('#grid').grid('destroy', true, true);

        grid1 = window.$('#grid').grid({
            primaryKey: 'wipNo',
            dataSource: [],
            width: '100%',
            headerFilter: {
                type: 'onchange'
            },
            columns: [...props.columns],
            pager: props.displayPagination ? { limit: 100, sizes: [10, 50, 100, 500, 1000, 2000, 5000] } : false
        });

        setTimeout(() => {
            storedFiltterValue = JSON.parse(localStorage.getItem('FiltterParams')) || {};
            props.columns.forEach((itm) => {
                if (storedFiltterValue) {
                    var id = $(grid1).attr('id');
                    var rowXPath = '#' + id + ' thead tr[data-role="filter"]';
                    var filterRow = $(rowXPath);
                    if ($(filterRow).length == 1) {
                        var colXPath = 'th [data-field="' + `${itm.field}` + '"]';
                        var filterInput = $(filterRow).find(colXPath);
                        if ($(filterInput).length && storedFiltterValue[`${itm.field}`]) {
                            $(filterInput).val(storedFiltterValue[`${itm.field}`]);
                            grid1.data().params[itm.field] = storedFiltterValue[`${itm.field}`];
                        }
                    }
                }
            });
            if (storedFiltterValue.sortBy && storedFiltterValue.direction) {
                grid1.data().params.sortBy = storedFiltterValue.sortBy;
                grid1.data().params.direction = storedFiltterValue.direction;
            }

            /*
            set the data source of the grid just once, and then trigger
            the reload, to pull the latest data with filter if any
            */
            setDataSource(grid1, props.getUrl);
            grid1.reload();
        });

        grid1.on('dataBound', function (e, records, totalRecords) {
            let { page, limit, ...rest } = grid1.data().params;
            let tempArray = storedFiltterValue;
            for (const property in rest) {
                tempArray = {
                    ...tempArray,
                    [`${property}`]: rest[property]
                };
            }
            localStorage.setItem('FiltterParams', JSON.stringify(tempArray));

            var ddl = $('<select class=" grid-filter-select"><option value="" ></option></select>');
            var supCd = grid1.data().params.branchShortName || '';
            $(branchList).each(function (i, itm) {
                if (supCd.length > 0 && itm.branchShortName == supCd) {
                    ddl.append(`<option value="${itm.branchShortName}" selected >${itm.branchShortName}</option>`);
                } else {
                    ddl.append(`<option value="${itm.branchShortName}" >${itm.branchShortName}</option>`);
                }
            });
            GijgoFilterExtension.Dropdown(grid1, 'branchShortName', ddl);

            var ddlFranchise = $('<select class=" grid-filter-select"><option value="" ></option></select>');
            var franchise = grid1.data().params.franchiseName || '';
            $(franchiseList).each(function (i, itm) {
                if (franchise.length > 0 && itm.franchiseName == franchise) {
                    ddlFranchise.append(`<option value="${itm.franchiseName}" selected >${itm.franchiseName}</option>`);
                } else {
                    ddlFranchise.append(`<option value="${itm.franchiseName}" >${itm.franchiseName}</option>`);
                }
            });
            GijgoFilterExtension.Dropdown(grid1, 'franchiseName', ddlFranchise);
        });

        // grid1.on('dataBound', function (e, records, totalRecords) {
        //     let { page, limit, ...rest } = grid1.data().params;

        //     const gridActionSpn = document.createElement('span');
        //     const gridActionGrid = (
        //         <Grid container justify="space-around">
        //             ssss
        //         </Grid>
        //     );
        //     ReactDOM.render(gridActionGrid, gridActionSpn);
        //     var gridActionSpnRef = gridActionSpn;
        //     if (props.showCheckboxColFilterBtn) {
        //         // $(`#${state.id}`).find('thead tr[data-role="caption"]> th:nth-child(1)').attr('width', '7%');

        //         // .removeAttr('width').attr('style', 'width: 10px !important');
        //         // console.log(a, 'oooooo');
        //         $(`#${'temp'}`)
        //             .find('thead tr[data-role="filter"] > th:nth-child(1)')
        //             .html(() => props.showCheckboxColFilterBtn(`#${state.id}`, records));
        //     }
        //     GijgoActionBtn(grid1, 'action', gridActionSpnRef);
        // });

        grid1.on('dataBound', function () {
            const id = $(grid1).attr('id');
            const filterRow = $(`#${id} thead tr[data-role="filter"]`);
            const filterCell = filterRow.find('th [data-field="action"]');

            if (filterCell.length) {
                // Clear and prepare a mount point
                filterCell.empty();
                const mountDiv = document.createElement('div');
                filterCell.append(mountDiv);

                // Render React component into the grid cell
                ReactDOM.render(
                    <Grid container justify="space-around">
                        <Grid item>
                            <button>Click Me</button>
                        </Grid>
                    </Grid>,
                    mountDiv
                );
            }
        });

        grid1.on('rowDataBound', function (e, $row, id, record) {
            $row.css('background-color', `white`);
            if (record.highPriority) {
                $row.css('background-color', `${portalSettings.portalHighPriorityJobColour}`);
            } else if (record.returnReasonColourCode) {
                $row.css('background-color', `${record.returnReasonColourCode}`);
            } else {
                const dtDueIn = moment(record.dateDueIn).format('MM/DD/YYYY');
                const daysPast = moment().diff(dtDueIn, 'days');
                if (daysPast > 40) {
                    $row.css('background-color', 'orange');
                } else if (daysPast > 5) {
                    $row.css('background-color', 'yellow');
                }
            }
        });
        grid1.on('cellDataBound', function (e, $displayEl, id, column, record) {
            $displayEl.css('color', `${record.returnReasonTextColourCode}`);
        });
        // grid1.reload();
    };

    const downloadCSVWrapper = async () => {
        if (!props.getUrl.includes('GetWorkflow')) {
            grid1?.downloadCSV(`${props.currentWorkflowLabel}-${moment().format('DD-MMM-YYYY HH:mm')}.csv`);
        } else {
            showToast('Collating Data... This may take a while.');

            const workflowID = localStorage.getItem('currentWorkflowId');
            const data = grid1.data().params;

            let params = `/${workflowID == 'All' ? '' : workflowID}?`;

            for (let key in data) {
                if (data.hasOwnProperty(key)) {
                    const value = data[key];
                    params += `&${key}=${value}`;
                }
            }

            await GetArchivedJobsExcelFile(params);
        }
    };

    return (
        <Grid
            container
            className="common-gijgo-grid custom-scroll-grid"
            style={{ overflowX: 'auto', position: 'relative', height: 'calc(100vh - 190px)', overflowY: 'auto' }}
        >
            <Grid item style={{ top: '33px', left: '18px', zIndex: 99, position: 'absolute' }}>
                <Tooltip title="Download CSV" arrow>
                    <IconButton aria-label="delete">
                        <CloudDownloadIcon fontSize="large" onClick={downloadCSVWrapper} />
                    </IconButton>
                </Tooltip>
            </Grid>

            <Grid container item alignItems="flex-start" alignContent="flex-start" xs={12} sm={12} style={{ margin: '10px 5px' }}>
                <table id="grid"></table>
            </Grid>
        </Grid>
    );
};
export default GijgoGrid;
